export default class KeyboardHelper {
    static isEsc(
        event: JQuery.KeyDownEvent
    ): boolean {
        const key = event.key;

        return key === 'Escape';
    }
}
